var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{attrs:{"disabled":_vm.isOnFreePlan,"type":_vm.isOnFreePlan ? 'is-grey--disabled' : 'is-primary',"loading":_vm.loading},on:{"click":_vm.enableDisableInstance}},[_vm._v(" "+_vm._s(_vm.isEnabled ? _vm.$t('integrations.details.button.pause') : _vm.$t('integrations.details.button.unpause'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }